import React from 'react';

interface HeroSectionProps {
    title: React.ReactNode;
    subtitle: React.ReactNode;
    highlights?: React.ReactNode;
}

export default function HeroSection({
    title,
    subtitle,
    highlights,
}: HeroSectionProps) {
    return (
        <section className="px-4 py-12">
            <div className="mx-auto max-w-4xl text-center">
                <h1 className="mb-6 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text pb-2 text-4xl font-bold leading-tight text-transparent md:text-6xl">
                    {title}
                </h1>
                <p className="mx-auto mb-8 max-w-2xl text-xl text-muted-foreground">
                    {subtitle}
                </p>
                {highlights ? (
                    <div className="flex items-center justify-center gap-4 text-sm text-muted-foreground">
                        {highlights}
                    </div>
                ) : null}
            </div>
        </section>
    );
}
